import React from "react";
import { ShieldCheck, Mountain, Flag, CloudRain, Handshake, Compass } from "lucide-react";
import { useLang } from "../lib/i18n";

const badgeDefs = {
  attested_guide_required: {
    icon: ShieldCheck,
    ru: { label: "Аттестованный экскурсовод", text: "Экскурсию проводит аттестованный экскурсовод Республики Алтай." },
    en: { label: "Attested guide", text: "Led by an attested guide of the Altai Republic." },
  },
  protected_area_permit_check: {
    icon: Mountain,
    ru: { label: "ООПТ", text: "Для маршрута может потребоваться оформление доступа или оплата установленного сбора. Актуальные условия проверяются перед поездкой." },
    en: { label: "Protected area", text: "Access registration or a fee may be required. Current conditions are checked before departure." },
  },
  border_zone_check: {
    icon: Flag,
    ru: { label: "Пограничная зона", text: "Для части маршрутов может потребоваться предварительное оформление разрешения. Условия зависят от маршрута и гражданства путешественника." },
    en: { label: "Border zone", text: "A permit may need to be arranged in advance, depending on the route and traveller nationality." },
  },
  instructor_guide_classification_review: {
    icon: Compass,
    ru: { label: "Активный маршрут", text: "Формат сопровождения зависит от сложности и официальной классификации конкретного маршрута." },
    en: { label: "Active route", text: "The accompaniment format depends on the difficulty and official classification of the route." },
  },
  weather_or_road_dependent: {
    icon: CloudRain,
    ru: { label: "Зависит от условий", text: "Порядок посещения и отдельные точки могут меняться в зависимости от погоды, состояния дорог и требований безопасности." },
    en: { label: "Weather dependent", text: "The order of visits and individual points may change with weather, road conditions and safety." },
  },
};

export const LegalBadges = ({ legal, compact = false }) => {
  const { lang } = useLang();
  if (!legal) return null;
  const active = Object.keys(badgeDefs).filter((k) => legal[k]);
  const hasPartner = Array.isArray(legal.partner_services) && legal.partner_services.length > 0;

  if (compact) {
    const chips = active.map((k) => badgeDefs[k][lang].label);
    if (hasPartner) chips.push(lang === "ru" ? "Услуга партнёра" : "Partner service");
    return (
      <div className="flex flex-wrap gap-2">
        {chips.map((c) => (
          <span key={c} className="text-[0.6rem] uppercase tracking-[0.14em] border border-argali-sandstone/40 text-argali-sandstone/90 px-2.5 py-1">
            {c}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {active.map((k) => {
        const Icon = badgeDefs[k].icon;
        const d = badgeDefs[k][lang];
        return (
          <div key={k} className="flex gap-4 border border-argali-brown/15 p-4" data-testid={`legal-${k}`}>
            <Icon size={20} className="text-argali-bronze shrink-0 mt-0.5" />
            <div>
              <p className="text-[0.7rem] uppercase tracking-[0.16em] text-argali-bronze font-semibold">{d.label}</p>
              <p className="text-sm text-argali-brown/80 mt-1 leading-relaxed">{d.text}</p>
            </div>
          </div>
        );
      })}
      {hasPartner && (
        <div className="flex gap-4 border border-argali-brown/15 p-4">
          <Handshake size={20} className="text-argali-bronze shrink-0 mt-0.5" />
          <div>
            <p className="text-[0.7rem] uppercase tracking-[0.16em] text-argali-bronze font-semibold">{lang === "ru" ? "Услуга партнёра" : "Partner service"}</p>
            <p className="text-sm text-argali-brown/80 mt-1 leading-relaxed">
              {lang === "ru"
                ? "Часть услуг (транспорт, лодка, снегоход, спец. сопровождение, размещение) может предоставляться проверенными партнёрами."
                : "Some services (transport, boat, snowmobile, specialist support, accommodation) may be provided by trusted partners."}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LegalBadges;
